import React from "react";
import Card from '@mui/joy/Card';
import CardContent from '@mui/joy/CardContent';
import Typography from '@mui/joy/Typography';
import Chip from '@mui/joy/Chip';
import Stack from '@mui/material/Stack';

const ValidationsCard = ({ id, validations, getValidationStats }) => {
  if (!validations || validations.length === 0) {
    return null;
  }

  return (
    <Card variant="outlined" sx={{ px: 3 }}>
      <CardContent>
        <Typography level="h3">Validations</Typography>
        <Typography level="body-md" mb={2}>Here are the validations for task no. {id}</Typography>
        {validations.map((validation, index) => (
          <React.Fragment key={index}>
            <Stack direction="row" justifyContent="space-between">
              <Stack direction="row">
                <Typography level="title-md" mr={1}>Field:</Typography>
                <Typography level="body-sm">{validation.fieldKey}</Typography>
              </Stack>
              <Chip color={validation.isValid ? "success" : "warning"}>
                {validation.isValid ? "Yes" : "No"}
              </Chip>
            </Stack>
            <Stack direction="row" justifyContent="space-between" mb={2}>
              <Typography level="body-sm">
                {validation.reason?.details || validation.reason || "No Reason Provided"}
              </Typography>
              <Chip>Confidence: {getValidationStats?.(validation.fieldKey) || "N/A"}</Chip>
            </Stack>
          </React.Fragment>
        ))}
      </CardContent>
    </Card>
  );
};

export default ValidationsCard;

